import { MatasPlusRecommendationViewModel } from 'autogen/swagger/all';
import { ProductRecommendationListPowerstepTwoModel } from 'autogen/swagger/all';
import useMediatorState, { mediatorAtom } from 'hooks/globals/useMediatorAtom';
import type { BasketPowerstepQuickViewProps } from '../../types';

export const BasketPowerstepQuickViewAtom = mediatorAtom<
    {
        isOpen: boolean;
    } & BasketPowerstepQuickViewProps
>({
    isOpen: false,
    checkoutUrl: ''
});

export default function useBasketPowerstepQuickView() {
    return useMediatorState(BasketPowerstepQuickViewAtom);
}
